import angular from 'angular';
import { IAfastamento } from '../models/afastamento.model';
import { IAnexo } from '../../Anexos/models/anexo.model';
import { TipoSolicitacaoEnum } from '../../../../shared/enums/TipoSolicitacaoEnum';
import { MeurhAfastamentosService } from '../afastamentos.service';
import { TiposDocumentosRequeridosService } from '../../../Tiposdocumentosrequeridos/tiposdocumentosrequeridos.service';
import { ModalConfirmService } from '../../../../shared/components/modal-confirm/modal.confirm.service';

export class MeurhAfastamentosNewController implements angular.IController {
	static $inject = [
        '$scope',
        '$state',
        'MeurhAfastamentosService',
        'NewToaster',
        '$rootScope',
        'TiposDocumentosRequeridosService',
        'ModalConfirmService',
        '$q',
        '$transitions'
    ];

    public action = 'insert';
	public form: angular.IFormController;
    public entity = {} as IAfastamento;
    public entitySave: Partial<IAfastamento> = {};
    public busy: boolean = false;
    public allowRefresh: boolean = false;
    public formchanged: boolean = false;
	public tiposdocumentosrequeridos: Array<any>;
	public validate: number = 0; // conta quantos erros há em documentos anexos
	public busyTipoDocumentos: boolean = true;
	public entityAnexo: IAnexo = {
        casodeuso: 'AFASTAMENTO'
    };
	public formAnexo: object = {};
	public editanexo: boolean = true;

    public afastamentoOrigemObj;

    constructor(
		public $scope: angular.IScope,
		public $state: angular.ui.IStateService,
        public entityService: MeurhAfastamentosService,
        public NewToaster: any,
        public $rootScope: angular.IRootScopeService & { liberadoTela: (arg: string) => boolean },
		public TiposDocumentosRequeridosService: TiposDocumentosRequeridosService,
        public ModalConfirmService: ModalConfirmService,
        public $q: angular.IQService,
        public $transitions: any
    ) {
        this.documentosAnexos();

		this.$scope.$on('meurh_tiposdocumentosrequeridos_list_finished', () => {
			this.busyTipoDocumentos = false;
			this.tiposdocumentosrequeridos = this.tiposdocumentosrequeridos.map((tipodocumentorequerido) => {
				tipodocumentorequerido.validateResult = false;
				tipodocumentorequerido.fileSelecionado = false;
				return tipodocumentorequerido;
			});
		});

        this.onSubmitSuccess();
        this.onSubmitError();
        this.exitScreenDescartarModal();
        document.onkeydown = this.refreshDescartarModal;
        this.allowRefresh = true;
    }

    documentosAnexos(): void {
        if (this.$rootScope.liberadoTela('LIBERAR_REFATORACAO_VISIBILIDADE')) {
            this.$scope.$watch('mrh_afstmts_frm_nw_cntrllr.entity.trabalhador', (newValue: any, oldValue: any) => {
                if (newValue && newValue !== oldValue) {
                    const params = {
                        empresa: newValue.empresaobj.empresa,
                        estabelecimento: newValue.estabelecimentoobj.estabelecimento
                    };
                    this.setEntityAnexo({ estabelecimento: params.estabelecimento });
                    this.carregaTiposDocumentosRequeridos(params);
                }
            }, true);
        } else {
            this.carregaTiposDocumentosRequeridos();
        }
    }

    carregaTiposDocumentosRequeridos(params?: {
        empresa: string,
        estabelecimento: string
    }): void {
        this.busyTipoDocumentos = true;
        this.resetTiposDocumentosRequeridosService();
        this.TiposDocumentosRequeridosService.constructors = {
            tiposolicitacao: TipoSolicitacaoEnum.AFASTAMENTO,
            ...params
        };
        this.tiposdocumentosrequeridos = this.TiposDocumentosRequeridosService.load();
    }

	resetTiposDocumentosRequeridosService(): void {
		this.TiposDocumentosRequeridosService.entities = [];
		this.TiposDocumentosRequeridosService.loadParams = {
			to_load: 3,
			busy: false,
			finished: false
		};
		this.TiposDocumentosRequeridosService.after = {};
	}

    setEntityAnexo(params: { estabelecimento: string }): void {
        this.entityAnexo['estabelecimento'] = params.estabelecimento;
    }

    createEntity(rascunho: boolean): void {
        this.entitySave.datainicio = this.entity.datainicio;
        this.entitySave.diasafastamento = this.entity.diasafastamento;
        this.entitySave.dataretorno = this.entity.dataretorno;
        this.entitySave.cid = this.normalizeCid(this.entity.cid);
        this.entitySave.medico = this.normalizeMedico(this.entity.medico);
        this.entitySave.descricao = this.entity.descricao;
        this.entitySave.tipohistorico = this.entity.tipohistorico;
        this.entitySave.trabalhador = this.entity.trabalhador.trabalhador;
        this.entitySave.semdataretorno = this.entity.semdataretorno ? 1 : 0;
        this.entitySave.peloinss = this.entity.peloinss ? 1 : 0;
        if (this.entity.observacao) {
            this.entitySave.observacao = this.entity.observacao;
        }
        this.entitySave.tiposolicitacao = TipoSolicitacaoEnum.AFASTAMENTO;
        if (rascunho === true) {
            this.entitySave.situacao = -1;
        } else {
            this.entitySave.situacao = 0;
        }

        if (this.entity.afastamentoorigem) {
            this.afastamentoOrigemObj = angular.copy(this.entity.afastamentoorigem);
            this.entitySave.afastamentoorigem = this.entity.afastamentoorigem.afastamentotrabalhador;
        } else {
            this.entitySave.afastamentoorigem = null;
        }

    }

    salvar(rascunho: boolean = false): void {
        let podeSalvar = this.tiposdocumentosrequeridos.every((tipodocumentorequerido) => {
            return (
                tipodocumentorequerido.fileSelecionado === tipodocumentorequerido.obrigatorio ||
                tipodocumentorequerido.fileSelecionado
            );
        });

        if (this.form.$valid && !this.entity.$$__submitting && podeSalvar) {
            this.allowRefresh = false;
            this.createEntity(rascunho);

            if (this.entity.afastamentoorigem) {
                let combinacaoValidaMotivoAfastamentoOrigem: boolean = this.validaCombinacaoMotivoAfastamentoOrigem(this.entity.tipohistorico, this.afastamentoOrigemObj.tipohistorico.tipohistorico);

                if (!combinacaoValidaMotivoAfastamentoOrigem) {
                    this.NewToaster.pop({
                        type: 'warning',
                        title: 'Motivos distintos',
                        body: 'O motivo do afastamento origem é diferente do motivo da prorrogação solicitada.'
                    });
                    return;
                }
            }

            if (this.entity.semdataretorno) {
                const textos = {
                    title: 'Afastamento sem previsão de retorno',
                    subtitle: 'Quando o colaborador retornar, será necessário informar o retorno por meio do botão "Retornar afastamento" na ficha do colaborador.',
                    confirmText: '',
                    confirmTextNum: '',
                    closeButton: 'Cancelar',
                    confirmButton: 'Enviar afastamento',
                };
                const confirm = this.ModalConfirmService.open(this.entity, 'Afastamento', false, textos);
                confirm.result.then(() => {
                    this.save();
                }).catch(() => {/**/});
            } else if (this.entity.peloinss) {
                const textos = {
                    title: 'Afastamento pelo INSS',
                    subtitle: 'A solicitação resultará em um afastamento pelo INSS, e notamos que a data de retorno já é conhecida.',
                    confirmText: 'Tem certeza que deseja enviar o afastamento?',
                    confirmTextNum: '',
                    closeButton: 'Cancelar',
                    confirmButton: 'Enviar afastamento',
                };
                const confirm = this.ModalConfirmService.open(this.entity, 'Afastamento', false, textos);
                confirm.result.then(() => {
                    this.save();
                }).catch(() => {/**/});
            } else {
                this.save();
            }
        } else {
            if (!podeSalvar) {
                this.NewToaster.pop({
                    type: 'error',
                    title: 'Há documento(s) obrigatório(s) não informado(s)'
                });
            } else {
                this.NewToaster.pop({
                    type: 'error',
                    title: 'Alguns campos do formulário apresentam erros.'
                });
            }
        }
    }

    save() {
        this.busy = true;
        this.entityService.save(this.entitySave, {
            empresa: this.entity.trabalhador.empresaobj.empresa,
            estabelecimento: this.entity.trabalhador.estabelecimentoobj.estabelecimento
        });
    }

    verificaObj(): boolean {

        let anexosObrigatoriosEnviados = true;
        if (this.tiposdocumentosrequeridos && this.tiposdocumentosrequeridos.length > 0) {
            anexosObrigatoriosEnviados = this.tiposdocumentosrequeridos.every((tipodocumentorequerido) => {
                return (
                    tipodocumentorequerido.fileSelecionado === tipodocumentorequerido.obrigatorio ||
                    tipodocumentorequerido.fileSelecionado
                );
            });
        }

        if (
            this.valorExiste(this.entity.trabalhador) &&
            this.valorExiste(this.entity.descricao) &&
            this.valorExiste(this.entity.tipohistorico) &&
            this.verificaDatas() &&
            this.form.$valid &&
            !this.form.datasSobrepostas &&
            anexosObrigatoriosEnviados
        ) {
            return false;
        } else {
            return true;
        }
    }

    verificaDatas() {
        const semDataRetornoValida = this.entity.semdataretorno && this.valorExiste(this.entity.datainicio);
        const comDataRetornoValida = !this.entity.semdataretorno &&
            (this.valorExiste(this.entity.diasafastamento) && this.entity.diasafastamento !== 0);
        return semDataRetornoValida || comDataRetornoValida;
    }

    onSubmitSuccess(): void {
        this.$scope.$on('meurh_solicitacoesafastamentos_submitted', (event: angular.IAngularEvent, args: any): void => {
            this.entityService.constructors.solicitacao = args.entity.solicitacao;
            this.entityAnexo['solicitacao'] = args.entity.solicitacao;

            this.$rootScope.$broadcast('meurh_todas_solicitacoes_submitted', {});
            if (this.tiposdocumentosrequeridos.length <= 0) {
                this.NewToaster.pop({
                    type: 'success',
                    title: 'Sucesso',
                    body: 'A solicitação de afastamento foi enviada com sucesso.'
                });
                this.$state.go('meurh_afastamentos_show', {'solicitacao': args.entity.solicitacao});
            } else {
                this.$scope.$on('meurh_todas_solicitacoes_documentos_complete', () => {
                    this.$scope.$apply();
                    if (this.tiposdocumentosrequeridos.every((tipodocumentorequerido) => tipodocumentorequerido.validateResult)) {
                        this.NewToaster.pop({
                            type: 'success',
                            title: 'Sucesso',
                            body: 'A solicitação de afastamento foi enviada com sucesso.'
                        });
                        this.$state.go('meurh_afastamentos_show', {'solicitacao': args.entity.solicitacao});
                    }
                });
            }

        });
    }

    onSubmitError(): void {
        this.$scope.$on('meurh_solicitacoesafastamentos_submit_error', (event: angular.IAngularEvent, args: any): void => {
            this.busy = false;
            if (args.response.status === 409) {
                this.NewToaster.pop({
                    type: 'error',
                    title: args.response.data.message
                });
            } else {
                if (
                    args.response.data &&
                    typeof (args.response.data.message) !== 'undefined' &&
                    args.response.data.message
                ) {
                    if (args.response.data.message === 'Validation Failed') {
                        let message = '';
                        let children = args.response.data.errors.children;
                        for (let child in children) {
                            if (children[child].errors !== undefined) {
                                for (let error in children[child].errors) {
                                    if (children[child].errors.hasOwnProperty(error)) {
                                        message += '<li>' + children[child].errors[error] + '</li>';
                                    }
                                }
                            }
                        }
                        this.NewToaster.pop({
                            type: 'error',
                            title: 'Erro de Validação',
                            body: 'Os seguintes itens precisam ser alterados: <ul>' + message + '</ul>',
                            bodyOutputType: 'trustedHtml'
                        });
                    } else {
                        this.NewToaster.pop({
                            type: 'error',
                            title: args.response.data.message
                        });
                    }
                } else {
                    this.NewToaster.pop({
                        type: 'error',
                        title: 'Ocorreu um erro ao enviar a Solicitação de Afastamento!'
                    });
                }
            }
        });
    }

    valorExiste(valor: any): boolean {
        return valor !== '' && valor !== undefined && valor !== null ? true : false;
    }

    formChange(): boolean {
        let existeDocumento = this.tiposdocumentosrequeridos?.some((tipodocumentorequerido) => {
            return tipodocumentorequerido.fileSelecionado === true;
        });
        if (
            this.valorExiste(this.entity.trabalhador) ||
            this.valorExiste(this.entity.descricao) ||
            this.valorExiste(this.entity.observacao) ||
            this.verificaDatas() ||
            existeDocumento
        ) {
            this.formchanged = true;
        }
        return this.formchanged;
    }

    buttonDescartarModal(): void {
        if (this.formChange()) {
            let confirm = this.ModalConfirmService.OpenDescartar(this.entity, ' criação', true);
            confirm.result.then((): void => {
                this.allowRefresh = false;
                this.$state.go('meurh_afastamentos', angular.extend(this.entityService.constructors));
            }).catch((error: any): void => {/**/});
        } else {
            this.$state.go('meurh_afastamentos', angular.extend(this.entityService.constructors));
        }
    }

    refreshDescartarModal = (e: any): void => {
        e = e || window.event;
        if (this.formChange() && this.allowRefresh) {
            if (e.keyCode === 116) {
                e.preventDefault();
                let confirm = this.ModalConfirmService.OpenDescartar(this.entity, ' criação', true);
                confirm.result.then((): void => {
                    this.allowRefresh = false;
                    window.location.reload();
                }).catch((error: any): void => {/**/});
            }
        }
    }

    exitScreenDescartarModal(): void {
        this.$transitions.onBefore({}, (trans: any) => {
            let d = this.$q.defer();
            if (
                trans._targetState._identifier !== 'meurh_solicitacoesafastamentos_new' &&
                this.allowRefresh &&
                this.formChange()
            ) {
                let confirm = this.ModalConfirmService.OpenDescartar(this.entity, ' criação', true);
                confirm.result.then((): void => {
                    this.allowRefresh = false;
                    let modalConfirmed = true;
                    if (modalConfirmed) {
                        d.resolve();
                    } else {
                        d.reject();
                    }
                }).catch(function () {/**/});
            } else {
                d.resolve();
            }
            return d.promise;
        });
    }

    /**
     * Método que verifica se a combinação entre motivo do afastamento e afastamento origem é válida
     * @param tipoHistorico Tipo de histórico selecionado no motivo
     * @param afastamentoOrigem O tipo de histórico do afastamento origem
     * @returns Booleano que informa se combinação é válida
     */
    validaCombinacaoMotivoAfastamentoOrigem(tipoHistorico: string, afastamentoOrigem: string) {

	        if ((tipoHistorico === '002' && afastamentoOrigem === '001') || (tipoHistorico === '004' && afastamentoOrigem === '003')) {
	            return true;
	        } else {
	            return false;
	        }

	    }

    private normalizeCid(cid?: string | null): string | null {
        const normalizedCid = cid ? cid.trim() : '';
        return normalizedCid || null;
    }

    private normalizeMedico(medico?: any): { medico: string } | null {
        return medico && medico.medico ? { medico: medico.medico } : null;
    }

	}
